import React, { useState } from 'react';
import SearchInput from './SearchInput';
import ResidentTable from './ResidentTable';
import useResidentFetch from './useResidentFetch';
import './styles.scss';

const ResidentList = ({
  partnerCarehomeId,
  carePlaceName,
}: {
  partnerCarehomeId: string;
  carePlaceName: string;
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const { tableData, totalPages, loading } = useResidentFetch(
    partnerCarehomeId,
    currentPage,
    searchText
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  return (
    <div className="flex flex-col mt-5 govuk-bp:mt-6">
      <h1 className="govuk-heading-l homepage-acp-title py-2 px-3">
        {carePlaceName} - Records
      </h1>
      <h1 className="govuk-heading-l">Record Search</h1>
      <p className="govuk-body">
        Current and historical records can be located and accessed using the
        &apos;Record Search&apos; tool.
      </p>

      <h3 className="govuk-heading-s">
        Search active and historical records by the person’s name.
      </h3>
      <SearchInput onChange={handleSearchChange} />
      <div className="overflow-x-auto">
        <div className="min-w-fit">
          <ResidentTable
            data={tableData}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
      </div>
    </div>
  );
};

export default ResidentList;
